module.exports = __webpack_public_path__ + "static/media/MinionPro-Regular.ccf4d373.eot";